import { createApp } from 'vue'
import App from './App.vue'

import './registerServiceWorker'
import {store} from './store/store'
import { initSentry } from './utils/sentry'
//createApp(App).mount('#app')

const app = createApp(App)

// Initialize Sentry BEFORE mount so mount-time errors are captured.
// No-op unless the tenant config set window.SENTRY_DSN.
initSentry(app)

app.use(store)

app.mount('#app')